import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import WaterEquipmentTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";

const WaterSymbioticlEquipmentContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="component-energy-contents" style={{ paddingLeft: "0" }}>
      <SubHeaderBox
        subTitle={t("EQUIPMENT_SYMBIOTIC")}
        number="2.4.3a"
        isNormal={true}
      />
      {showTable && (
        <WaterEquipmentTable businessId={businessId} category={"symbiotic"} />
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default WaterSymbioticlEquipmentContents;
